// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
    background-color: #d4dce3;
    overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/themes/app.css"],"names":[],"mappings":"AAAA;;IAEI,yBAAyB;IACzB,gBAAgB;AACpB","sourcesContent":["body,\nhtml {\n    background-color: #d4dce3;\n    overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
